<div class="material">
    <div class="header">
        <h5>{{ 'admin.tools.details.strainMeasurementsPage.title' | translate }}</h5>
    </div>
    <app-strain-measurements-list class="content"
                                  [isLoading]="isLoading"
                                  [canDelete]="false"
                                  [canEdit]="false"
                                  [measurements]="getToolMeasurements()"
                                  (reportClick)="onReportClick($event)">
    </app-strain-measurements-list>
</div>
